export default {
      id: "chevron-left-blue-usage",
      viewBox: "0 0 13 22",
      url: "/" + "sprite.svg#chevron-left-blue",
      toString: function () {
        return this.url;
      }
    }